import { PRECISE_THRUST } from '../cards/attack/precise-thrust';
import { ENFEEBLE } from '../cards/support/enfeeble';
import { PANDEMIC } from '../cards/support/pandemic';
import { MIRROR } from '../cards/trap/mirror';
import type { EnemyTemplate } from './template';

/** HEX-83 roster (docs/enemies.md). Epic tier: 4×3, 4 dice, optimal-vs-player AI.
 * A debuff engine that punishes counter-play — stacks heavy poison and weaken
 * (the epic AI values both), and the passive Mirror means every status *you*
 * throw rebounds onto you. Forces you to win on raw damage, not control. */
export const HEX_WEAVER: EnemyTemplate = {
  id: 'hex-weaver',
  name: 'Hex Weaver',
  glyph: '✥', // woven asterisk — the spun web
  tier: 'epic',
  hp: 36,
  loadout: [
    { card: PANDEMIC, origin: { row: 0, col: 0 }, rotated: false },
    { card: ENFEEBLE, origin: { row: 0, col: 2 }, rotated: false },
    { card: MIRROR, origin: { row: 2, col: 0 }, rotated: false },
    { card: PRECISE_THRUST, origin: { row: 2, col: 2 }, rotated: false },
  ],
  drops: { gold: 20 },
};
